export default __webpack_public_path__ + "static/media/big-thick-icon.de033365.svg";